import React, {ReactChild, ReactChildren} from "react";
import clsx from 'clsx';
import './FieldsetCustom.scss';

interface Props {
  children: ReactChild | ReactChildren,
  containerClassName?: string;
  error?: string;
  errorId?: string;
  invalid?: boolean;
  legend: string;
  legendHeader?: boolean;
  legendClassName?: string;
  radioContainerClassName?: string;
  fieldsetRef?: any,
  row?: boolean,
  wrapperClassName?: string,
  wrapperRow?: boolean;
}

const FieldsetCustom: React.FC<Props> = ({ 
  children,
  containerClassName,
  error,
  errorId,
  invalid,
  legend,
  legendHeader,
  legendClassName,
  radioContainerClassName,
  fieldsetRef,
  row,
  wrapperClassName,
  wrapperRow,
  ...props
}) => {
  const containerClassNameClsx = clsx(['fieldset-container', containerClassName]);
  const legendClassNameClsx = clsx(['fieldset-custom__legend', legendHeader && 'fieldset-custom__legend--header', legendClassName]);
  const radioClassName = clsx([
    'fieldset-custom__radio-container',
    invalid && 'fieldset-custom__radio-container--invalid',
    row && 'fieldset-custom--row',
    radioContainerClassName,
  ]);
  const wrapperClassNameClsx = clsx([
    'fieldset-content-wrapper',
    wrapperRow && 'fieldset-content-wrapper--row',
    wrapperClassName,
  ]);

  return (
    <fieldset className={containerClassNameClsx} ref={fieldsetRef} {...props}>
      <div className={wrapperClassNameClsx}>
        <legend className={legendClassNameClsx}>{legend}</legend>
        <div className={radioClassName}>
          <>
            {children}
          </>
        </div>
      </div>
      {errorId && <p id={errorId} className="fieldset-custom__error" role="alert">{error}</p>}
    </fieldset>
  )
};

export default FieldsetCustom;